import React from 'react';
import EventsListPage from '../components/events/EventsListPage';

export default function Events() {
  return <EventsListPage pageType="event" />;
}
